<template>
  <Modal>
    <div styleName="classAuthorith">
      <header styleName="header">
        {{ $t('setPermissions') }}
        <span styleName="closeBtn" @click="_close"></span>
      </header>
      <ul styleName="listBody">
        <li styleName="listItem">
          <span styleName="desc">{{ $t('permissionOfSendingMessage') }}:</span>
          <div styleName="choice" @change="_switchChatStatus">
            <label styleName="radioLabel"><input styleName="radio" type="radio" name="wordChat" value="1" :checked="allowChatWithMessage">{{ $t('yes') }}</label>
            <label styleName="radioLabel"><input styleName="radio" type="radio" name="wordChat" value="0" :checked="!allowChatWithMessage">{{ $t('no') }}</label>
          </div>
        </li>
        <li styleName="listItem">
          <span styleName="desc">{{ $t('showOnlineUser') }}:</span>
          <div styleName="choice" @change="_switchUserNum">
            <label styleName="radioLabel"><input styleName="radio" type="radio" name="userNum" value="1" :checked="showUserNum">{{ $t('yes') }}</label>
            <label styleName="radioLabel"><input styleName="radio" type="radio" name="userNum" value="0" :checked="!showUserNum">{{ $t('no') }}</label>
          </div>
        </li>
        <li styleName="listItem">
          <span styleName="desc">{{ $t('timeLagOfSending') }}:</span>
          <div styleName="choice">
            <input styleName="messageTime" type="number" :value="timeToSendMessage" @change="_changeTime" />
            <span>{{ $t('seconds') }}</span>
          </div>
        </li>
      </ul>
    </div>
  </Modal>
</template>
<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
import Modal from '@/components/Modal'
import { signalSdk } from '@/utils/getSDK'
import sensorLog from '@/utils/sensorLog'
import * as types from '@/constants'

export default {
  mixins: [CSSModules(styles)],
  data () {
    return {
      saveStore: []
    }
  },
  computed: {
    allowChatWithMessage () {
      return this.$store.state.chatBox.allowChatWithMessage
    },
    showUserNum () {
      return this.$store.state.chatBox.showUserNum
    },
    timeToSendMessage () {
      return Number(this.$store.state.chatBox.timeToSendMessage)
    }
  },
  methods: {
    _close () {
      let p1, p2, p3
      if (!this.saveStore || !this.saveStore.length) {
        return this.$store.dispatch('switchModalStatus', false)
      }
      if (this.saveStore[0] !== this.allowChatWithMessage) {
        if (!this.allowChatWithMessage) {
          p1 = signalSdk.chatboxSlient()
        } else {
          p1 = signalSdk.cancelChatboxSlient()
        }
      }
      if (this.saveStore[1] !== this.showUserNum) {
        if (this.showUserNum) {
          p2 = signalSdk.showOnlineUserCount()
        } else {
          p2 = signalSdk.hideOnlineUserCount()
        }
      }
      if (this.saveStore[2] !== this.timeToSendMessage) {
        p3 = signalSdk.setMessageInterval(this.timeToSendMessage)
      }
      Promise.all([p1, p2, p3]).then((data) => {
        this.$store.dispatch('switchModalStatus', false)
        this.saveStore = []
        sensorLog.track("chat_box_authorize", types.SENSORLOG.type.SUCCESSED)
      }).catch((err) => {
        this.saveStore = []
        this.$store.dispatch('switchModalStatus', false)
        sensorLog.track("chat_box_authorize", types.SENSORLOG.type.FAILED, err)
      })
    },
    _switchChatStatus (e) {
      this.saveOriginData()
      this.$store.dispatch('switchAllowChatWithMessage', e.target.value === '1')
    },
    _switchUserNum (e) {
      this.saveOriginData()
      this.$store.dispatch('switchShowUserNum', e.target.value === '1')
    },
    _changeTime (e) {
      this.saveOriginData()
      this.$store.dispatch('changeTimeToSendMessage', Number(e.target.value))
    },
    saveOriginData () {
      if (this.saveStore.length) {
        return
      }
      this.saveStore.push(this.allowChatWithMessage, this.showUserNum, this.timeToSendMessage)
    }
  },
  components: {
    Modal
  }
}
</script>
